import React, { useState,useEffect } from "react";
import { FaShoppingCart, FaHeart, FaLeaf, FaStar, FaSeedling, FaTint, FaBoxOpen } from "react-icons/fa";

const PlantCard = ({ plant = {}, onOrderClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Ensure all required fields have defaults
  const {
    name = "نبات غير مسمى",
    price = 0,
    quantity = 0,
    image = "",
    sold_status = false,
    type = "نبات",
    tags = "0",
    care = "غير معروف",
  } = plant;

  const formattedPrice = typeof price === "number" ? price.toFixed(2) : "0.00";

  const getCareIcon = (careType) => {
    const careStr = careType?.toLowerCase() || '';
    if (careStr.includes('سهل') || careStr.includes('easy')) return '🌱';
    if (careStr.includes('متوسط') || careStr.includes('medium')) return '🌿';
    if (careStr.includes('صعب') || careStr.includes('hard')) return '🌳';
    return '🌱';
  };

  const getCareColor = (careType) => {
    const careStr = careType?.toLowerCase() || '';
    if (careStr.includes('سهل') || careStr.includes('easy')) return '#10b981';
    if (careStr.includes('متوسط') || careStr.includes('medium')) return '#f59e0b';
    if (careStr.includes('صعب') || careStr.includes('hard')) return '#ef4444';
    return '#10b981';
  };

  const getQuantityColor = (qty) => {
    if (qty === 0) return '#ef4444';
    if (qty <= 5) return '#f59e0b';
    return '#22c55e';
  };

  const getQuantityStatus = (qty) => {
    if (qty === 0) return 'نفذت الكمية';
    if (qty <= 5) return 'كمية محدودة';
    return 'متوفر';
  };

  // Handle order button click - call the parent's onOrderClick function
  const handleOrderClick = () => {
    if (onOrderClick) {
      const orderItem = {
        ...plant,
        id: plant.id || `plant_${Date.now()}`,
      };
      onOrderClick(orderItem);
    }
  };
  useEffect(() => {
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    setIsLiked(favorites.includes(plant.id));
  }, [plant.id]);
  
  const toggleFavorite = () => {
    const newLikedState = !isLiked;
    setIsLiked(newLikedState);
    
    // Update localStorage
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    if (newLikedState) {
      if (!favorites.includes(plant.id)) {
        localStorage.setItem('favorites', JSON.stringify([...favorites, plant.id]));
      }
    } else {
      localStorage.setItem('favorites', JSON.stringify(favorites.filter(id => id !== plant.id)));
    }
  };

  return (
    <>
      <style>{`
        .plant-card {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .plant-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px -5px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(34, 197, 94, 0.3);
        }
        
        .plant-image {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .plant-card:hover .plant-image {
          transform: scale(1.05);
        }
        
        .heart-button {
          transition: all 0.3s ease;
          backdrop-filter: blur(8px);
        }
        
        .heart-button:hover {
          transform: scale(1.1);
          background: rgba(0, 0, 0, 0.8) !important;
        }
        
        .heart-button.liked {
          animation: heartBeat 0.6s ease;
        }
        
        @keyframes heartBeat {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        
        .plant-type-badge {
          background: rgba(0, 0, 0, 0.7);
          color: #22c55e;
          padding: 6px 12px;
          borderRadius: 20px;
          fontSize: 12px;
          fontWeight: bold;
          display: flex;
          alignItems: center;
          gap: 6px;
          border: 1px solid rgba(34, 197, 94, 0.3);
        }
        
        .info-row {
          transition: all 0.2s ease;
        }
        
        .info-row:hover {
          background: rgba(34, 197, 94, 0.05);
          transform: translateX(-4px);
        }
        
        .price-tag {
          text-shadow: 0 2px 8px rgba(251, 191, 36, 0.3);
        }
        
        .primary-button {
          background: linear-gradient(135deg, #22c55e, #16a34a);
          border: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }
        
        .primary-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.6s;
        }
        
        .primary-button:hover::before {
          left: 100%;
        }
        
        .primary-button:hover {
          background: linear-gradient(135deg, #16a34a, #15803d);
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(34, 197, 94, 0.4);
        }
        
        .sold-out-button {
          background: linear-gradient(135deg, rgba(107, 114, 128, 0.3), rgba(75, 85, 99, 0.3));
          color: #9ca3af;
          border: 1px solid rgba(107, 114, 128, 0.4);
        }
        
        .loading-skeleton {
          background: linear-gradient(90deg, rgba(51, 65, 85, 0.3) 25%, rgba(51, 65, 85, 0.5) 50%, rgba(51, 65, 85, 0.3) 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }
        
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        
        @media (max-width: 768px) {
          .plant-card {
            min-height: 520px;
          }
          
          .plant-image-container {
            height: 220px !important;
          }
          
          .info-container {
            padding: 16px !important;
          }
        }
      `}</style>

      <div
        className="plant-card"
        style={{
          background: "linear-gradient(135deg, rgba(15, 23, 42, 0.80), rgba(30, 41, 59, 0.68))",
          backdropFilter: "blur(2px)",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(71, 85, 105, 0.2)",
          width: "100%",
          height: "100%",
          minHeight: "580px",
          border: "1px solid rgba(34, 197, 94, 0.2)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Status Badge */}
        {(sold_status || quantity === 0) && (
          <div className="floating-badge" style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            background: "linear-gradient(135deg, #ef4444, #dc2626)",
            color: "white",
            padding: "8px 14px",
            borderRadius: "25px",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: 10,
            boxShadow: "0 6px 20px rgba(239, 68, 68, 0.4)",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}>
            <FaStar size={12} />
            نفذت الكمية
          </div>
        )}

        {/* Low Stock Badge */}
        {quantity > 0 && quantity <= 5 && !sold_status && (
          <div className="floating-badge quantity-pulse" style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            background: "linear-gradient(135deg, #f59e0b, #d97706)",
            color: "white",
            padding: "8px 14px",
            borderRadius: "25px",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: 10,
            boxShadow: "0 6px 20px rgba(245, 158, 11, 0.4)",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}>
            <FaBoxOpen size={12} />
            كمية محدودة
          </div>
        )}

        {/* Like Button */}
     <button
    className={`heart-button ${isLiked ? 'liked' : ''}`}
    onClick={toggleFavorite}  // Changed from setIsLiked
    style={{
      position: "absolute",
      top: "16px",
      right: "16px",
      background: "rgba(0, 0, 0, 0.6)",
      border: "none",
      borderRadius: "50%",
      width: "44px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: isLiked ? "#ef4444" : "white",
      cursor: "pointer",
      zIndex: 10,
    }}
  >
    <FaHeart size={18} />
  </button>

        {/* Image Container */}
        <div
          className="plant-image-container"
          style={{
            width: "100%",
            height: "260px",
            background: "linear-gradient(135deg, rgba(15, 23, 42, 0.25), rgba(30, 41, 59, 0.15))",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            flexShrink: 0,
          }}
        >
          {image ? (
            !imageLoaded ? (
              <div className="loading-skeleton" style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#64748b",
                fontSize: "48px",
              }}>
                🌱
              </div>
            ) : null
          ) : (
            <div className="leaf-icon" style={{
              color: "#64748b",
              fontSize: "64px",
              opacity: 0.5,
            }}>
              <FaLeaf />
            </div>
          )}
          
          {image && (
            <img
              className="plant-image"
              src={image}
              alt={name}
              loading="lazy"
              style={{ 
                width: "100%", 
                height: "100%", 
                objectFit: "cover",
                opacity: imageLoaded ? 1 : 0,
                position: imageLoaded ? "static" : "absolute",
                transition: "opacity 0.3s ease-in-out",
              }}
              onLoad={() => setImageLoaded(true)}
            />
          )}

          <div className="plant-type-badge" style={{
            position: "absolute",
            bottom: "12px",
            right: "12px",
            backdropFilter: "blur(8px)",
          }}>
            <FaSeedling size={12} />
            {type}
          </div>
        </div>

        {/* Content */}
        <div className="info-container" style={{ 
          padding: "20px", 
          display: "flex", 
          flexDirection: "column", 
          flex: 1,
          gap: "16px"
        }}>
          <div style={{
            background: "linear-gradient(135deg, rgba(34, 197, 94, 0.08), rgba(22, 163, 74, 0.08))",
            border: "1px solid rgba(34, 197, 94, 0.2)",
            borderRadius: "16px",
            padding: "16px",
            flex: 1,
          }}>
            {/* Name field */}
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(34, 197, 94, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#22c55e", fontWeight: "bold", fontSize: "14px" }}>
                الاسم
              </span>
              <span style={{ 
                color: "white", 
                fontSize: "15px", 
                fontWeight: "600",
                textAlign: "right",
                wordBreak: "break-word",
                maxWidth: "60%"
              }}>
                {name}
              </span>
            </div>

            {/* Price field */}
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(34, 197, 94, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#22c55e", fontWeight: "bold", fontSize: "14px" }}>
                السعر
              </span>
              <span className="price-tag" style={{ 
                color: "#fbbf24", 
                fontSize: "18px", 
                fontWeight: "bold",
              }}>
                {formattedPrice} DA
              </span>
            </div>

            {/* Quantity field */}
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(34, 197, 94, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#22c55e", fontWeight: "bold", fontSize: "14px" }}>
                الكمية المتاحة
              </span>
              <span style={{ 
                color: getQuantityColor(quantity), 
                fontSize: "14px", 
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "8px",
                background: `${getQuantityColor(quantity)}15`,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                <FaBoxOpen size={12} />
                {quantity} قطعة
              </span>
            </div>

            {/* Tags field */}
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(34, 197, 94, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#22c55e", fontWeight: "bold", fontSize: "14px" }}>
                عدد الفروع
              </span>
              <span style={{ 
                color: "white", 
                fontSize: "14px", 
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "8px",
                background: "rgba(34, 197, 94, 0.15)",
              }}>
                {tags}
              </span>
            </div>

            {/* Care field */}
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(34, 197, 94, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#22c55e", fontWeight: "bold", fontSize: "14px" }}>
                العناية
              </span>
              <span style={{ 
                color: getCareColor(care), 
                fontSize: "14px", 
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "8px",
                background: `${getCareColor(care)}15`,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                <span>{getCareIcon(care)}</span>
                {care}
              </span>
            </div>

            {/* Status field */}
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}>
              <span style={{ color: "#22c55e", fontWeight: "bold", fontSize: "14px" }}>
                الحالة
              </span>
              <span className={(!sold_status && quantity > 0) ? "status-available" : ""} style={{
                color: getQuantityColor(quantity),
                fontSize: "14px",
                fontWeight: "600",
                padding: "6px 12px",
                borderRadius: "12px",
                background: `${getQuantityColor(quantity)}15`,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                <FaTint size={12} />
                {getQuantityStatus(quantity)}
              </span>
            </div>
          </div>

          {/* Action Button */}
          <div style={{ marginTop: "auto" }}>
            {(!sold_status && quantity > 0) ? (
              <button 
                className="primary-button card-button"
                onClick={handleOrderClick}
                style={{
                  borderRadius: "16px",
                  padding: "14px 20px",
                  color: "white",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  boxShadow: "0 6px 20px rgba(34, 197, 94, 0.3)",
                  minHeight: "52px",
                  width: "100%",
                }}
              >
                <FaShoppingCart size={16} />
                اطلب الآن
              </button>
            ) : (
              <div className="sold-out-button card-button" style={{
                borderRadius: "16px",
                padding: "14px 20px",
                fontSize: "15px",
                fontWeight: "bold",
                textAlign: "center",
                minHeight: "52px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                width: "100%",
              }}>
                <FaStar size={14} />
                تم البيع
              </div>
            )}
          </div>
        </div>

        {isHovered && (
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(135deg, rgba(34, 197, 94, 0.05), rgba(22, 163, 74, 0.05))",
            borderRadius: "24px",
            pointerEvents: "none",
          }} />
        )}
      </div>
    </>
  );
};

export default React.memo(PlantCard);